export default __webpack_public_path__ + "static/media/Page7.9f7fade0.txt";